import styled, { keyframes } from 'styled-components'
import { BORDER_RADIUS } from '../../../styles/theme'

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`

export const SkeletonBox = styled.div<{
  $width?: string
  $height?: string
  $radius?: string
}>`
  background: linear-gradient(
    90deg,
    var(--color-bg-skeleton) 25%,
    var(--color-bg-skeleton-highlight) 50%,
    var(--color-bg-skeleton) 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: ${({ $radius }) => $radius ?? BORDER_RADIUS.sm};
  width: ${({ $width }) => $width ?? '100%'};
  height: ${({ $height }) => $height ?? '16px'};
  flex-shrink: 0;
`
